<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<app-search-template searchLabel="Search" [showSearchButton]=true [reset]=true
  [showDevelopments]=true [showShortTermRentals]=true [showBedrooms]=true
  [showStartDate]=true [showEndDate]=true [showSaleDateStart]="true" [showSaleDateEnd]="true"
  [showYieldMaxRateBuckets]=true [showPropertyRanks]="true" [showBlankStartAndEndDate]=true
  [showNumNts]="true" [showReferralSources]=true [displayRecordsOnPageLoad]=true
  (doSearchCB)="onSearchSubmit($event)">
</app-search-template>

<div class="row g-3 m-0 mb-4 pb-3 pt-0 report-statistics">
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="statistics bg-1">
      <p>Average Lead Time:</p>
      <h1>{{reservations.avgPrebookDays | number : '1.2-2'}}d</h1>
    </div>
  </div>
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="statistics bg-2">
      <p>Average LOS:</p>
      <h1>{{reservations.avgNightsStay | number : '1.2-2'}}d</h1>
    </div>
  </div>
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="statistics bg-3">
      <p>ADR:</p>
      <h1>{{reservations.avgAdr | currency : 'USD' : 'symbol' : '1.0-0'}}</h1>
    </div>
  </div>
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="statistics bg-4">
      <p>ADR from Direct:</p>
      <h1>{{reservations.avgAdrWebsiteRes | currency : 'USD' : 'symbol' : '1.0-0'}}</h1>
    </div>
  </div>
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="statistics bg-5">
      <p>ADR from OTA:</p>
      <h1>{{reservations.avgAdrOtherRes | currency : 'USD' : 'symbol' : '1.0-0'}}</h1>
    </div>
  </div>
</div>

<p-table #pt [value]="reservations.resADRReportAPIDetailList" selectionMode="single"
  [loading]="loading" [paginator]="true" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  sortMode="multiple" styleClass="p-datatable-striped"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Reservations</h1>
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    <tr>
      @for (col of columns; track col) {
        <th [ngStyle]="{'width': 'auto'}">
          <input pInputText type="text" [ngStyle]="{'width':'50px','min-width':'100%'}" (input)="pt.filter($event.target.value, col.field, 'contains')" style="width: 100%">
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-res>
    <tr>
      <td> {{ res.addressDevelopmentName }} </td>
      <td> {{ res.propertyRankName }} </td>
      <td> {{ res.propertyCode }} </td>
      <td> {{ res.bedrooms }} </td>
      <td> {{ res.reservationId }} </td>
      <td> {{ res.checkInDate | date:'MM-dd-yyyy' }} </td>
      <td> {{ res.checkOutDate | date:'MM-dd-yyyy' }} </td>
      <td> {{ res.saleDate | date:'MM-dd-yyyy' }} </td>
      <td> {{ res.prebookDays }} </td>
      <td> {{ res.numberOfNightsStay }} </td>
      <td> {{ res.nightlyRateTTL | number:'1.2-2' }} </td>
      <td> {{ res.nightlyRate | number:'1.2-2' }} </td>
      <td> {{ res.refSrcName }} </td>
      <td> {{ res.resStatusName }} </td>
    </tr>
  </ng-template>
</p-table>